<div class="auth-page">
  <div class="auth-card">
    <h1 class="auth-heading">Password reset isn't available yet.</h1>
    <p class="auth-subtitle">
      The self-service password reset flow hasn't been built in Uniformax yet.
      Please contact your administrator to have your password reset.
    </p>

    <div class="text-center mt-6">
      <a routerLink="/login" class="text-primary font-medium hover:underline">Back to sign in</a>
    </div>
  </div>
</div>
